// auth
export const AUTH_LOGIN = "/Authenticate/ClientUserLogin";
export const IDENTITY_LOGIN = "[V2]/Authenticate/IdentityLogin/";
export const AUTH_FORGOT_PASS = "/Authenticate/ClientUserForgotPassword";
export const AUTH_VERIFY_LINK = "/Authenticate/ValidateClientUserResetUrl";
export const AUTH_VALIDATE_OTP = "/Authenticate/ValidateOTP";
export const AUTH_RESET_PASSWORD = "/Authenticate/ResetClientUserPassword";
export const GET_BUILD_VERSION = "/Authenticate/GetClientBuildVersion"

export const VETERAN_STATUS_TYPES = "[V2]/dropdowns/veteranStatusTypes";
export const ETHNICITY_TYPES = "[V2]/dropdowns/ethnicityTypes";
export const RACE_TYPES = "[V2]/dropdowns/raceTypes";
export const EDUCATION_LEVEL_TYPES = "[V2]/dropdowns/educationLevelTypes";
export const DISABILITY_TYPES = "[V2]/dropdowns/disabilityTypes";
export const ASSIGN_RAP_INFOS = "[V2]/dropdowns/assignRapInfos";
export const CAREER_CONNECTION_TYPES = "[V2]/dropdowns/careerConnectionTypes";
export const GET_ALL_DOCUMENTS = "/ProScoreEmployee/GetAllDocumentByEmployee";
export const GET_DOCUMENT_FROM_S3 = "/ProScoreEmployee/GetDocumentFromS3Bucket";
export const DOWNLOAD = "[V2]/download";
export const EMPLOYEES = "[V2]/employees";
export const GET_PROJECT_DETAILS = "/ProScoreEmployee/GetProjectDetails";
export const GET_ALL_PROJECT_APPRENTICE = "/ApprenticeMentorMapping/GetMentorApprenticeDropDown";
export const REQUEST_APPRENTICE = "/ApprenticeMentorMapping/AddProjectApprenticeMentor";
export const APPRENTICE_REQUEST_DETAILS = "/ApprenticeMentorMapping/GetApprenticeRequestDetails";
export const ACCEPT_REJECT_MENTOR_REQUEST = "/ApprenticeMentorMapping/AcceptOrRejectMentorRequest";
export const GET_ALL_PROJECT_BY_EMPLOYEE = "[V2]projects/GetAllProjectsByEmployee";

export const APPRENTICE_DASHBOARD_DETAILS = "[V2]/rap/apprenticeDashboardDetails";
export const UPLOAD_EMPLOYEE_PROFILE = "/Employee/UploadEmployeeProfile";
export const GET_ALL_USER_NOTIFICATION = "/ClientUserNotification/GetAllClientUserNotification";
export const UPDATE_USER_NOTIFICATION = "/ClientUserNotification/UpdateClientUserNotification";

export const GET_APPRENTICE_MENTORS = "[V2]/apprenticeMentors/employeeHistories";
export const GET_APPRENTICE_FORM_STATUS = "[V2]/rap/apprenticeFormAndDocumentStatus";
export const APPRENTICE_FORM_AND_DOCUMENT_STATUS = "[V2]/rap/apprenticeFormAndDocumentStatus"
export const UPDATE_APPRENTICE_SIGNATURE_STATUS = "/ProScoreEmployee/UpdateApprenticeSignatureStatus";
export const GET_ALL_VIDEOS = "/Video/GetAllVideos";

// mentor Time allocation
export const GET_ALL_EMPLOYEE_TIME_ALLOCATION = "[V2]/rap/employeeWpsTimeAllocations";
export const GET_EMPLOYEE_TIME_ALL_ACTIVITY = "[V2]/rap/employeeWpsActivities";
export const ADD_EMPLOYEE_WPS_TIME_ALLOCATION = "[V2]/rap/employeeWpsTimeAllocations";
export const APPROVE_REJECT_WPS_TIME_ALLOCATION = "[V2]/employeeCourse/ApproveAndRejectApprenticeWPS";


// courses method

export const GET_EMPLOYEE_COURSES = "[V2]/employeeCourse/GetEmployeeCourseDetails";
export const WPS_AUTO_LOGIN = "/wp-json/ts/v1/autologin";

// empployee documents
export const GET_ALL_EMPLOYEE_DOCUMENTS = "[V2]/employees/{employeeId}/documents";
export const GET_EMPLOYEE_DOCUMENTS_BY_ID = "[V2]/employees/{employeeId}/documents";
export const DELETE_EMPLOYEE_DOCUMENT = "[V2]/employees/{employeeId}/documents";
export const GET_ALL_EMPLOYEE_DOCUMENT_TYPE = "[V2]/dropdowns/types";
export const ADD_EMPLOYEE_DOCUMENT = "[V2]/employees/{employeeId}/documents";
export const UPDATE_EMPLOYEE_DOCUMENT = "[V2]/employees/{employeeId}/documents";

export const GET_EMPLOYEE_WPS_ALLOCATION_SETTING = "[V2]/rap/GetEmpoloyeeWPSAllocationSetting";


//identity
export const IDENTITY_LOGIN_REDIRECT = "identity/account/login";